import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import { config, LOG_OUT } from '../../constants';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import { Button, Input, message, Select, Switch} from 'antd';
import { EditOutlined, ReadOutlined } from '@ant-design/icons';


export default class AddOrUpdateUserComponent extends React.Component{

    constructor(props){
        super(props);

        const userID = this.props.match.params.userID
        const pageMode = userID ? "update" : "add";

        this.state = {
            pageMode: pageMode,
            userID: userID,
            companies: ["No Company"],
            roles: [],
            user: {
                roles:[],
                company:"No Company",
                enabled: true
                }
        }

        if(this.state.pageMode == "update"){axios.get(config.AUTH_URL + "user/" + userID, {headers: authHeader()}).then(response => {

            var userData = response.data

            userData.company = userData.company || "No Company"
            userData.roles = userData.roles.length == 0 ? [] : userData.roles

            this.setState({user:userData})

        })}
        
        axios.get(config.AUTH_URL + "user/get-companies", {headers: authHeader()}).then(response => {
            
            var copyState = this.state;
            copyState.companies.push(...response.data);

            this.setState(copyState)
        })

        axios.get(config.AUTH_URL + "user/get-roles", {headers: authHeader()}).then(response => {
            
            var copyState = this.state;
            copyState.roles = response.data;

            this.setState(copyState)
        })

    }

    addUser = () => {
        const {name, surname, email, accountID, password, company, enabled, roles} = this.state.user;

        const user = {name, surname, email, accountID, password, company, enabled, roles};

        AuthService.addUser(user, authHeader).then(
            response => {
                let success = response.data;
                if (success) {
                    window.location = "/user-controller";
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )

    }
    
    updateUser = () => {
        const {name, surname, email, accountID, password, company, enabled, roles} = this.state.user;

        const user = {name, surname, email, accountID, password, company, enabled, roles};  
        
        AuthService.updateUser(user, authHeader, this.state.userID).then(
            response => {
                let success = response.data;
                if (success) {
                    window.location = "/user-controller";
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
    }


    handleInputChange = (e) => {
        const {name, value} = e.target

        this.setState(prevState => ({
            user: {
                ...prevState.user,
                [name]: value
            }
        }))

    }

    handleCompanyChange = (value) => {

        this.setState(prevState => ({
            user: {
                ...prevState.user,
                company: value
            }
        }))

    }

    handleRolesChange = (roles) => {

        this.setState(prevState => ({
            user: {
                ...prevState.user,
                roles: roles
            }
        }))

    }

    handleSwitchChange = (e) => {

        this.setState(prevState => ({
            user: {
                ...prevState.user,
                enabled: !this.state.user.enabled
            }
        }))

    }


    render(){
        
        return(

            <>
            <section className="user-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-user custom-ant-input-wrapper">
                                <div>
                                    <form method="POST" action="">
                                        <div className='form-box-user-input'>
                                            <Input 
                                                type="text"
                                                   value={this.state.user.name}
                                                   name="name"
                                                   placeholder={i18n.t('user_input_name')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>
                                        <div className='form-box-user-input'>
                                            <Input type="text"
                                                value={this.state.user.surname}
                                                   name="surname"
                                                   placeholder={i18n.t('user_input_surname')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>
                                        <div className='form-box-user-input'>
                                            <Input type="email"
                                            value={this.state.user.email}
                                                   name="email"
                                                   placeholder={i18n.t('user_input_email')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>
                                        <div className='form-box-user-input'>
                                            <Input type="text"
                                                value={this.state.user.accountID}
                                                   name="accountID"
                                                   placeholder={i18n.t('user_input_accountID')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>
                                        <div className='form-box-user-input'>
                                            <Input type="text"

                                                   name="password"
                                                   placeholder={i18n.t('user_input_password')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}
                                                   />
                                        </div>

                                        <div className="custom-ant-selection">
                                            <Select
                                                value={this.state.user.company}
                                                showSearch
                                                allowClear
                                                suffixIcon={<ReadOutlined/>}
                                                optionFilterProp="children"
                                                onChange={value => this.handleCompanyChange(value)}

                                            >
                                                {
                                                    this.state.companies.map(company => (
                                                        <Select.Option key={company} value={company}>{company}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>

                                        <div className="custom-ant-selection">
                                            
                                            <Select
                                            mode="multiple"
                                            allowClear
                                            style={{
                                                width: '100%',
                                            }}
                                            value={this.state.user.roles}
                                            placeholder="Please select"
                                            onChange={roles => this.handleRolesChange(roles)}
                                            >
                                            {
                                                    this.state.roles.map(role => (
                                                        <Select.Option key={role} value={role}>{role}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                            
                                        </div>

                                        <div className="pb-20">
                                        
                                            <span className="ml-20 mr-20">{i18n.t('user_input_enabled')}</span>
                                            <Switch
                                                checked = {this.state.user.enabled}
                                                onChange={this.handleSwitchChange}
                                                name="enabled"
                                                checkedChildren={i18n.t('user_input_enabled')}
                                                unCheckedChildren={i18n.t('user_input_disabled')}
                                            />
                                        </div>
                                        <Button
                                            className="custom-button"
                                            type="button"
                                            onClick={this.state.pageMode == "update" ? this.updateUser : this.addUser}
                                            >
                                            {this.state.pageMode == "update" ? i18n.t('update_user') : i18n.t('add_user')}
                                        </Button> 
                                        </form>
                                        
                                                                           
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            
            </>
            
        );

    }

}